<template>
  <div class="modal_wrap system on" v-show="showDialog">
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head" v-if="dialogTitle">
          <h1 class="h1">{{ dialogTitle }}</h1>
        </div>
        <div class="modal_con">
          <div class="modal_txt">
            <div class="center" v-if="dialogHtml" v-html="dialogMessage"></div>
            <div class="center" v-else>{{ dialogMessage }}</div>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button
              class="btn"
              @click="dialogCancel"
              v-if="dialogType === 'confirm'"
            >
              취소
            </button>
            <button class="btn" @click="dialogOk">
              {{ dialogOkText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from '@common/store/modules/common';
import * as actions from '@common/store/modules/common/types';
import * as getters from '@common/store/modules/common/getters';
export default {
  computed: {
    ...mapGetters({
      showDialog: getters.SHOW_DIALOG,
      dialogType: getters.DIALOG_TYPE,
      dialogTitle: getters.DIALOG_TITLE,
      dialogMessage: getters.DIALOG_MESSAGE,
      dialogHtml: getters.DIALOG_HTML,
      dialogIcon: getters.DIALOG_ICON,
    }),
    dialogClass() {
      return this.dialogIcon === 'withdraw' ? 'withdraw' : '';
    },
    dialogLogo() {
      /*if (this.dialogIcon === 'withdraw' || this.dialogIcon === 'warning')
        return require('@/assets/images/i_warning.png');
      else if (this.dialogIcon === 'version')
        return require('@/assets/images/logo_version.png');
      else if (this.dialogIcon === 'contact')
        return require('@/assets/images/i_call.png');*/
      return '';
    },
    dialogOkText() {
      return this.dialogIcon === 'withdraw' ? '탈퇴' : '확인';
    },
  },
  watch: {
    showDialog() {
      if (this.showDialog) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
  },
  methods: {
    ...mapActions([actions.DIALOG_OK, actions.DIALOG_CANCEL]),
    dialogCancel() {
      this[actions.DIALOG_CANCEL]();
    },
    dialogOk() {
      this[actions.DIALOG_OK]();
    },
  },
};
</script>
